var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeture3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_181",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4521 37.2606C20.9332 37.2195 18.4311 37.6778 16.0891 38.6093C13.7471 39.5407 11.6113 40.9269 9.80416 42.6884C7.99703 44.4499 6.5541 46.552 5.5581 48.8743C4.5621 51.1966 4.03261 53.6934 4 56.2215V59.1772M23.1429 42.9208C19.628 42.9208 16.2571 44.3221 13.7717 46.8164C11.2864 49.3108 9.89011 52.6939 9.89011 56.2215V65.0886M23.4521 48.5218C21.4361 48.5813 19.519 49.4116 18.0929 50.8428C16.6667 52.2741 15.8394 54.1982 15.7802 56.2215V71M34.4666 25.29C33.7902 23.4649 33.4461 21.5327 33.4506 19.5854C33.4476 16.9536 34.0694 14.3589 35.2646 12.0163C36.4597 9.67375 38.1938 7.65063 40.3231 6.11455C42.4525 4.57846 44.9158 3.57363 47.5091 3.18326C50.1025 2.79289 52.7512 3.02822 55.2358 3.86977C57.7205 4.71131 59.9696 6.13485 61.797 8.02248C63.6243 9.91011 64.9772 12.2075 65.7437 14.7244C66.5102 17.2413 66.6682 19.9052 66.2046 22.4956C65.741 25.086 64.6691 27.5282 63.0778 29.6201M71 39.9651L48.1758 16.3194L30.5055 29.6201L35.6446 39.9651L30.8736 39.433C29.6508 39.3016 28.4489 39.0187 27.2954 38.5906L25.2191 37.3197C25.1561 37.2865 25.0855 37.2703 25.0143 37.2726C24.9432 37.2749 24.8738 37.2957 24.813 37.3329C24.7522 37.3701 24.7021 37.4225 24.6674 37.4849C24.6328 37.5473 24.6149 37.6177 24.6154 37.6892V48.1524C24.6149 48.2238 24.6328 48.2942 24.6674 48.3566C24.7021 48.4191 24.7522 48.4714 24.813 48.5086C24.8738 48.5458 24.9432 48.5666 25.0143 48.5689C25.0855 48.5712 25.1561 48.555 25.2191 48.5218C26.6403 47.6764 28.2208 47.1362 29.8607 46.9352C31.5006 46.7343 33.1642 46.877 34.7464 47.3543C38.2523 48.2992 41.4701 50.1018 44.1116 52.6007L47.8666 56.2215C48.1115 56.5438 48.4199 56.8121 48.7725 57.0097C49.1251 57.2073 49.5144 57.3301 49.9163 57.3702C50.3182 57.4104 50.724 57.3672 51.1086 57.2433C51.4931 57.1194 51.8482 56.9175 52.1516 56.65L71 39.9651Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeture3);
export default __webpack_public_path__ + "static/media/feture3.f5bc47eb0cfc497e931573cb5a48593b.svg";
export { ForwardRef as ReactComponent };